export const FETCH_LOGIN = 'FETCH_LOGIN';
export const FETCH_OTP = 'FETCH_OTP';
export const FETCH_REGISTER = 'FETCH_REGISTER';
export const FETCH_ACTION = 'FETCH_ACTION';
export const IS_AUTHENTICATED = 'IS_AUTHENTICATED'
